































































































import TemplateModule from "@/store/modules/form/TemplateModule"
import { Component, Ref, Vue } from "vue-property-decorator"

import TemplateDescriptorForm from "@/components/dashboard/SurveyManagement/TemplateDescriptorForm.vue"
import TemplateYearForm from "@/components/dashboard/SurveyManagement/TemplateYearForm.vue"
import ConfirmDeletionDialog from "@/components/elements/dialog/ConfirmDeletionDialog.vue"
import Button from "@/components/inputs/Button.vue"
import ButtonGroup from "@/components/inputs/ButtonGroup.vue"
import TextField from "@/components/inputs/TextField.vue"
import LayoutLoadable from "@/components/layouts/LayoutLoadable.vue"
import TemplateDescriptorType from "@/model/enum/form/template/templateDescriptorType"
import { Template } from "@/model/interfaces/form/template/template"
import { TemplateDescriptor } from "@/model/interfaces/form/template/templateDescriptor"
import TemplateService from "@/services/form/TemplateService"
import SurveySubmissionService from "@/services/submission/surveySubmission/SurveySubmissionService"
import SurveySubmissionModule from "@/store/modules/submission/SurveySubmissionModule"
import { ValidationObserver, ValidationProvider } from "vee-validate"

@Component({
  computed: {
    TemplateDescriptorType() {
      return TemplateDescriptorType
    }
  },
  components: {
    TemplateYearForm,
    TextField,
    ConfirmDeletionDialog,
    ButtonGroup,
    TemplateDescriptorForm,
    Button,
    LayoutLoadable,
    ValidationObserver,
    ValidationProvider
  }
})
export default class SurveyManagementTemplate extends Vue {
  @Ref("form") readonly form!: InstanceType<typeof ValidationObserver>

  isAsyncExported: { display: boolean; error: boolean; templateId?: number } = { display: false, error: false, templateId: undefined }

  readonly HEADER = [
    this.$t("dashboard.surveymanagement.template.columns.koboId"),
    this.$t("dashboard.surveymanagement.template.columns.title"),
    this.$t("dashboard.surveymanagement.template.columns.year"),
    this.$t("dashboard.surveymanagement.template.columns.created"),
    this.$t("dashboard.surveymanagement.template.columns.lastUpdate"),
    this.$t("dashboard.surveymanagement.template.columns.numberOfSubmissions"),
    this.$t("dashboard.surveymanagement.template.columns.url"),
    this.$t("dashboard.surveymanagement.template.columns.fileReport"),
    this.$t("dashboard.surveymanagement.template.columns.fileSummary"),
    this.$t("dashboard.surveymanagement.template.columns.exportData")
  ]

  get templates(): Template[] {
    return TemplateModule.templates
  }

  templateDescriptorByType(template: Template, type: TemplateDescriptorType): TemplateDescriptor | null {
    return TemplateService.getTemplateDescriptorByType(template, type)
  }

  templateDescriptorContentUrlByType(template: Template, type: TemplateDescriptorType): string | null {
    return TemplateService.getTemplateDescriptorByType(template, type)?.contentUrl ?? null
  }

  templateDescriptorFileNameByType(template: Template, type: TemplateDescriptorType): string | null {
    return TemplateService.getTemplateDescriptorByType(template, type)?.filePath ?? "templateDescriptor.json"
  }

  get loading(): boolean {
    return TemplateModule.loading
  }

  get fileLoading(): boolean {
    return TemplateModule.fileLoading
  }

  async mounted(): Promise<void> {
    await TemplateModule.getTemplates()
  }

  async exportDataByTemplate(template: Template): Promise<void> {
    SurveySubmissionModule.isDataCleaned(true)
    const asyncExportedResult = await SurveySubmissionService.exportByTemplate(template, SurveySubmissionModule.filters, true)
    this.isAsyncExported = { display: asyncExportedResult as boolean, error: !asyncExportedResult, templateId: template.id }
    setTimeout(() => {
      this.isAsyncExported = { display: false, error: false, templateId: undefined }
    }, 5000)
  }

  openFormDialog(template: Template, type: TemplateDescriptorType): void {
    TemplateModule.setTemplateDialogForm(template)
    TemplateModule.setTemplateDescriptorTypeDialogForm(type)
    TemplateModule.setFileDialogForm(true)
  }

  async remove(template: Template, type: TemplateDescriptorType): Promise<void> {
    TemplateModule.setFileLoading(true)
    TemplateModule.setTemplateDescriptorTypeDialogForm(type)
    await TemplateModule.deleteFileDescriptor(template)
    await TemplateModule.getTemplates()
    TemplateModule.setFileLoading(false)
  }

  get asyncExportedMessage(): string {
    if (!this.isAsyncExported.error) {
      return "The export is being processed. You will receive an notification when the export is ready."
    } else {
      return "The export has failed."
    }
  }

  get asyncExportedStatus(): string {
    if (!this.isAsyncExported.error) {
      return "success"
    } else {
      return "error"
    }
  }

  hasAlert(template: Template): boolean {
    return (this.isAsyncExported.display || this.isAsyncExported.error) && this.isAsyncExported.templateId === template.id
  }
}
